import styled, { keyframes } from "styled-components";

interface Props {
  children: React.ReactNode;
  onClick?: () => void;
  type?: "submit" | "button";
}

export default function ButtonGradient({
  children,
  onClick,
  type = "button",
}: Props) {
  return (
    <StyledButton onClick={onClick} type={type}>
      {children}
    </StyledButton>
  );
}

const glowPulse = keyframes`
  0% {
    box-shadow: 0 0 0 rgba(0, 217, 255, 0.0);
  }
  50% {
    box-shadow: 0 0 12px rgba(0, 217, 255, 0.4);
  }
  100% {
    box-shadow: 0 0 0 rgba(0, 217, 255, 0.0);
  }
`;

const borderMove = keyframes`
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 200% 50%;
  }
`;

const StyledButton = styled.button`
  position: relative;
  color: ${({ theme }) => theme.THEME.white};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 27}px;
  font-weight: 550;
  padding: 14px 28px;
  border-radius: 12px;
  cursor: pointer;
  font-family: "Sora", sans-serif;
  background: ${({ theme }) => theme.THEME.purpleCiano};
  border: none;
  z-index: 1;
  overflow: hidden;
  transition: transform 0.3s ease;
  animation: ${glowPulse} 2s ease-in-out infinite;

  &:active {
    transform: scale(0.96);
  }

  &::before {
    content: "";
    position: absolute;
    inset: -2px;
    z-index: -1;
    background: ${({ theme }) => theme.THEME.purpleCiano};
    background-size: 200%;
    animation: ${borderMove} 8s linear infinite;
    border-radius: 14px;
    filter: blur(6px);
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      transform: scale(1.04);
      filter: drop-shadow(0 0 6px ${({ theme }) => theme.THEME.neonBlue});
    }
  }

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 7.5}px;
  }
`;
